import { render } from "./ProblemDetails.vue?vue&type=template&id=6dd9e6f0&scoped=true"
import script from "./ProblemDetails.vue?vue&type=script&lang=js"
export * from "./ProblemDetails.vue?vue&type=script&lang=js"

import "./ProblemDetails.vue?vue&type=style&index=0&id=6dd9e6f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dd9e6f0"]])

export default __exports__